import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, booleanAttribute, computed, input } from '@angular/core';

import { LazyLoadImageModule, StateChange } from 'ng-lazyload-image';

import { IntersectionObserverDirective } from '../../utils/intersection-observer/intersection-observer.directive';

export enum IntersectionStatus {
    Visible = 'Visible',
    Pending = 'Pending',
    NotVisible = 'NotVisible',
}

export class ImageStyles {
    gameTileBorderRadius: string | undefined;
}

@Component({
    selector: 'cs-image-loader',
    templateUrl: './image-loader.component.html',
    standalone: true,
    styleUrl: './image-loader.component.scss',
    imports: [LazyLoadImageModule, IntersectionObserverDirective, NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageLoaderComponent {
    @Input({ transform: booleanAttribute }) isLegacy = true;
    @Input({ transform: booleanAttribute }) disableLazyLoading = true;
    @Input({ transform: booleanAttribute }) isDll = true;
    @Input({ transform: booleanAttribute }) enableFallback = true;
    @Input({ transform: booleanAttribute }) isImageLoaded = false;
    @Input() defaultSrc: string;
    readonly src = input.required<string>();
    readonly lazySrc = input.required<string>();
    readonly icon = input.required<ImageStyles>();
    readonly isBlockModuleVersion = input<boolean>(false);

    @Output() readonly visibilityChanged = new EventEmitter<IntersectionStatus>();
    computedStyle = computed(() => this.getComputedStyle(this.icon()));

    onImageStateChanged(event: StateChange) {
        if (event.reason === 'loading-succeeded') {
            this.isImageLoaded = true;
        }
    }

    onGameIconError(src: string): void {
        this.defaultSrc = src;
    }

    onVisibilityChanged(elementIntersect: IntersectionStatus) {
        this.visibilityChanged.emit(elementIntersect);
    }

    getComputedStyle(icon: ImageStyles) {
        return this.isImageLoaded
            ? `border-radius: ${icon.gameTileBorderRadius}; background-color: 'unset'`
            : `border-radius: ${icon.gameTileBorderRadius};`;
    }
}
